











































import { computed, defineComponent, ref } from "@vue/composition-api";
import { isEqual } from "lodash-es";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { BaseMenuItem } from "@/types";
import { sortFields } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import SelectTagsModal from "@/components/SelectTagsModal";

export default defineComponent({
  name: "DiscoverFilters",
  components: {
    BaseMenu,
    BaseIconButton,
    BaseIcon,
    SelectTagsModal,
  },
  props: {
    selectedTags: { type: Array as () => TagInfo[], required: true },
    selectedSort: { type: String, default: "newest" },
    tagsType: { type: String as () => TagInfoType, required: true },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();
    const showSelectTags = ref(false);
    const showCreatorsSlider = computed(() => config.featureDiscoveryCreators);
    const allowSearch = computed(() => config.featureSearchBar && !showCreatorsSlider.value);
    const allowThemes = computed(() => config.featureTags || config.featureHashtags);
    const allowSort = computed(() => config.featureTags && !config.featureHashtags);
    const sortItems = computed<BaseMenuItem[]>(() =>
      sortFields.map(i => ({
        text: i.title,
        name: i.slug,
        class: i.slug === props.selectedSort ? "fw-600" : "",
      }))
    );
    const selectTagsModalTitle = computed(() => (config.featureHashtags ? $t("Hashtags") : $t("Filters")));
    const selectedSortTitle = computed(() => sortFields.find(item => item.slug === props.selectedSort)?.title);

    const activeFilterName = computed(() => {
      if (config.featureHashtags) {
        return props.selectedTags.length === 0
          ? $t("Recent Posts")
          : props.selectedTags.length === 1
          ? props.selectedTags[0].title
          : $t("{0} categories", [props.selectedTags.length]);
      } else {
        return props.selectedTags.length === 0
          ? selectedSortTitle.value
          : props.selectedTags.length === 1
          ? `${selectedSortTitle.value}, ${props.selectedTags[0].title}`
          : `${selectedSortTitle.value}, ${$t("{0} categories", [props.selectedTags.length])}`;
      }
    });

    const updateRoute = async (tags: TagInfo[], sort: string) => {
      await root.$router.push({
        name: root.$route.name || "discover",
        query: {
          tag: tags.map(tag => tag.slug),
          sort: sort !== "random" ? sort : undefined,
        },
      });
    };

    const onSortSelect = async (sort: string) => {
      if (props.selectedSort === sort) return;
      await updateRoute(props.selectedTags, sort);
    };

    const onTagsSelect = async (tags: TagInfo[]) => {
      showSelectTags.value = false;
      if (isEqual(tags, props.selectedTags)) return;
      await updateRoute(tags, props.selectedSort);
    };

    return {
      authUser,
      showSelectTags,
      showCreatorsSlider,
      allowSearch,
      allowThemes,
      allowSort,
      activeFilterName,
      selectTagsModalTitle,
      sortItems,
      onTagsSelect,
      onSortSelect,
    };
  },
});
